'use client';

import { useState } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { FiveStarRating } from 'assets/icons/FiveStarRating';
import { FormattedReview } from './useReviews';
import styles from './ReviewCard.module.css';

// const formatDate = (dateString: string) => {
//   try {
//     const date = new Date(dateString);
//     const month = date.toLocaleDateString('en-US', { month: 'short' });
//     const day = date.getDate();
//     const year = date.getFullYear();
//     return `${month} ${day}, ${year}`;
//   } catch {
//     return '';
//   }
// };

interface ReviewCardProps {
  review: FormattedReview;
  className?: string;
  truncateWords?: number;
}

const truncateByWords = (text: string, maxWords: number) => {
  const words = text.trim().split(/\s+/);
  if (words.length <= maxWords) return text;
  return words.slice(0, maxWords).join(' ') + '…';
};

export const ReviewCard = ({
  review,
  className,
  truncateWords,
}: ReviewCardProps) => {
  const t = useTranslations('common');
  // Bazaarvoice UGC photos can 404 (moderated/expired) — hide the slot
  // instead of showing a broken-image box.
  const [photoFailed, setPhotoFailed] = useState(false);
  const displayedContent = review.content
    ? truncateWords
      ? truncateByWords(review.content, truncateWords)
      : review.content
    : '';
  return (
    <div className={`${styles.root}${className ? ` ${className}` : ''}`}>
      {review.title && <h3 className={styles.reviewTitle}>{review.title}</h3>}

      <div className={styles.reviewTopRow}>
        <div
          className={styles.reviewStars}
          aria-label={t('reviewCard.text.ratingAriaLabel', {
            rating: review.rating,
            maxRating: review.max_rating,
          })}
        >
          <FiveStarRating rating={review.rating} />
        </div>
        {/** Repeat purchase tag if available in data */}
        {Boolean((review as any).repeat_purchase) && (
          <span className={styles.reviewRepeat}>
            {t('reviewCard.text.repeatPurchase')}
          </span>
        )}
      </div>
      {displayedContent && (
        <q className={styles.reviewContent}>{displayedContent}</q>
      )}
      {review.photos && review.photos.length > 0 && !photoFailed && (
        <div className={styles.reviewImage}>
          <Image
            src={review.photos[0]}
            alt={review.title || t('reviewCard.text.reviewImageAlt')}
            width={400}
            height={300}
            onError={() => setPhotoFailed(true)}
          />
        </div>
      )}
      <div className={styles.reviewFooter}>
        {review.name && <span className="review-author">{review.name}</span>}
        {/* {review.submission_date && (
            <span className="review-date">{formatDate(review.submission_date)}</span>
          )} */}
      </div>
    </div>
  );
};
